var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_828_6128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#BAEAC8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 16.296V14.976L35.7419 9.36H37.6979V14.832H38.7539V16.296H37.6979V18H36.0179V16.296H31.8179ZM36.1259 11.16L33.6659 14.832H36.1259V11.16ZM44.5155 6.636L41.2755 20.172H39.6315L42.8715 6.636H44.5155ZM51.5394 10.704H47.6514V12.756C47.8194 12.548 48.0594 12.38 48.3714 12.252C48.6834 12.116 49.0154 12.048 49.3674 12.048C50.0074 12.048 50.5314 12.188 50.9394 12.468C51.3474 12.748 51.6434 13.108 51.8274 13.548C52.0114 13.98 52.1034 14.444 52.1034 14.94C52.1034 15.86 51.8394 16.6 51.3114 17.16C50.7914 17.72 50.0474 18 49.0794 18C48.1674 18 47.4394 17.772 46.8954 17.316C46.3514 16.86 46.0434 16.264 45.9714 15.528H47.6034C47.6754 15.848 47.8354 16.104 48.0834 16.296C48.3394 16.488 48.6634 16.584 49.0554 16.584C49.5274 16.584 49.8834 16.436 50.1234 16.14C50.3634 15.844 50.4834 15.452 50.4834 14.964C50.4834 14.468 50.3594 14.092 50.1114 13.836C49.8714 13.572 49.5154 13.44 49.0434 13.44C48.7074 13.44 48.4274 13.524 48.2034 13.692C47.9794 13.86 47.8194 14.084 47.7234 14.364H46.1154V9.228H51.5394V10.704Z",
    fill: "#2A2A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51436 9.15868C6.19689 9.33505 6 9.66967 6 10.0328V14.6715C6 18.3032 7.96892 21.6494 11.1436 23.4131L13.5144 24.7302C13.8164 24.898 14.1836 24.898 14.4856 24.7302L16.8564 23.4131C20.0311 21.6494 22 18.3032 22 14.6715V10.0328C22 9.66967 21.8031 9.33505 21.4856 9.15868L14.4856 5.26979C14.1836 5.102 13.8164 5.102 13.5144 5.26979L6.51436 9.15868ZM12.9697 17.5303C13.2626 17.8232 13.7374 17.8232 14.0303 17.5303L18.0303 13.5303C18.3232 13.2374 18.3232 12.7626 18.0303 12.4697C17.7374 12.1768 17.2626 12.1768 16.9697 12.4697L13.5 15.9393L12.0303 14.4697C11.7374 14.1768 11.2626 14.1768 10.9697 14.4697C10.6768 14.7626 10.6768 15.2374 10.9697 15.5303L12.9697 17.5303Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_828_6128",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_828_6128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_828_6128",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO1);
export default __webpack_public_path__ + "static/media/o1.e1e2a033b4c646550aa1663a1db3edbb.svg";
export { ForwardRef as ReactComponent };